import React from "react";
import HouseIcon from "@mui/icons-material/House";
import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";

const Contact = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-4 col-md-12 col-sm-12 mt-5">
          <div className="address text-center">
            <div className="address-info mt-3">
              <HouseIcon
                style={{
                  fontSize: "50px",
                  borderRadius: "26px",
                  backgroundColor: "#b92626c7",
                  color: "white",
                  padding: "8px",
                }}
              />
              <h5
                className="mt-2"
                style={{
                  color: "#b92626c7",
                }}
              >
                Address
              </h5>
              <p
                style={{
                  color: "#b92626c7",
                }}
              >
                Railway station veraval ,<br /> Near Rarsh Complex
                <b> - 362265</b>
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-12 col-sm-12 mt-5">
          <div className="email text-center">
            <div className="email-info mt-3">
              <EmailIcon
                style={{
                  fontSize: "50px",
                  borderRadius: "26px",
                  backgroundColor: "#b92626c7",
                  color: "white",
                  padding: "8px",
                }}
              />
              <h5
                className="mt-2"
                style={{
                  color: "#b92626c7",
                }}
              >
                Email Id
              </h5>
              <a href="mailto:infosarthiinfoteck@gmail.com" target="blank">
                infosarthiinfoteck@gmail.com
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-12 col-sm-12 mt-5">
          <div className="contact text-center">
            <div className="contact-info mt-3">
              <CallIcon
                style={{
                  fontSize: "50px",
                  borderRadius: "26px",
                  backgroundColor: "#b92626c7",
                  color: "white",
                  padding: "8px",
                }}
              />
              <h5
                className="mt-2"
                style={{
                  color: "#b92626c7",
                }}
              >
                Mobile No
              </h5>
              <b
                style={{
                  color: "#b92626c7",
                }}
              >
                9979076950
              </b>
              /
              <b
                style={{
                  color: "#b92626c7",
                }}
              >
                7984142504
              </b>
              /
              <b
                style={{
                  color: "#b92626c7",
                }}
              >
                8460338075
              </b>
              ,
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
